import React, { useEffect, useState, useRef } from 'react';
import Spinner from '../../Spinner';
import centroid from '@turf/centroid';
import shelterIcon from '../../../assets/icons/shelter-icon-2.png';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';

export default function NearbyShelters({ nearbyShelters, latitude, longitude, map, calculateShelterDistance, getToken, setNearbyShelters }) {
    const popupRef = useRef(null);

    const showShelterPopup = (coords, shelter) => {
        if (popupRef.current) popupRef.current.remove();

        const { name, full_name, full_address, distance_km, website, phone } = shelter;

        popupRef.current = new mapboxgl.Popup({
            offset: 25,
            maxWidth: '300px',
            className: 'popup'
        })
        .setLngLat(coords)
        .setHTML(`
        <div>
            <div class='alert-popup-title'>Shelter: ${name ? name : full_name ? full_name : full_address ? full_address : 'Unknown Name'}</div>
            <div class='alert-popup-row'>
                <div class='alert-popup-row-name'>Distance:</div>
                <div class='alert-popup-row-value'>${distance_km ? `${(distance_km / 1.609).toFixed(2)} miles` : 'Unavailable'}</div>
            </div>                                           
        </div>
        `)
        .addTo(map.current);
    };
    const getShelters = () => {
        getToken().then((token) => {
            axios.get(`https://firewatch-api.space-eyes.com/shelters?latitude=${latitude}&longitude=${longitude}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                console.log('new shelters:', response.data.shelters);
                console.log(response.data.shelters[0]);
                setNearbyShelters(response.data.shelters);

                map.current.getStyle().layers
                    .filter(l => l.id.startsWith('Layer-Shelter-'))
                    .forEach(l => map.current.removeLayer(l.id));

                ['Source-Shelters','Source-Shelter-Routes'].forEach(src => {
                if (map.current.getSource(src)) map.current.removeSource(src);
                });

                if (map.current.hasImage('shelter-icon')) {
                map.current.removeImage('shelter-icon');
                }

                // load your shelter icon
                map.current.loadImage(shelterIcon, (err, image) => {
                if (err) throw err;
                map.current.addImage('shelter-icon', image);

                // 1️⃣ — add a GeoJSON source for the shelter points
                map.current.addSource('Source-Shelters', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: response.data.shelters.map(s => ({
                    type: 'Feature',
                    properties: s,
                    geometry: {
                        type: 'Point',
                        coordinates: s.coordinates
                    }
                    }))
                }
                });

                // 2️⃣ — symbol layer for the shelter icons
                map.current.addLayer({
                id: 'Layer-Shelter-Symbol',
                type: 'symbol',
                source: 'Source-Shelters',
                layout: {
                    'icon-image':            'shelter-icon',
                    'icon-size':             0.35,
                    'icon-allow-overlap':    true,
                    'icon-ignore-placement': true
                }
                });

                // 3️⃣ — add a GeoJSON source for your evacuation routes
                map.current.addSource('Source-Shelter-Routes', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: response.data.shelters.map(s => ({
                    type: 'Feature',
                    properties: s,
                    geometry: {
                        type: 'LineString',
                        coordinates: s.route_geometry
                    }
                    }))
                }
                });

                // 4️⃣ — line layer for the routes
                map.current.addLayer({
                id: 'Layer-Shelter-Routes',
                type: 'line',
                source: 'Source-Shelter-Routes',
                layout: {
                    'line-join':  'round',
                    'line-cap':   'round'
                },
                paint: {
                    'line-color': '#FF4136',
                    'line-width': 4,

                }
                });

                map.current.on('click', 'Layer-Shelter-Symbol', (e) => {
                    if (!e.features || !e.features.length) return;
                    const feature = e.features[0];

                    // 1️⃣ get the [lng, lat] for the popup
                    const coords = feature.geometry.coordinates;

                    const { name, full_name, full_address, distance_km, website, phone } = feature.properties;

                    let currentPopup = null;

                    // 3️⃣ remove any existing popup
                    if (currentPopup) currentPopup.remove();
        
                    // 4️⃣ build & show the new popup
                    currentPopup = new mapboxgl.Popup({
                        offset: 25,
                        maxWidth: '300px',
                        className: 'popup'
                        })
                        .setLngLat(coords)
                        .setHTML(`
                        <div>
                            <div class='alert-popup-title'>Shelter: ${name ? name : full_name ? full_name : full_address ? full_address : 'Unknown Name'}</div>
                            <div class='alert-popup-row'>
                                <div class='alert-popup-row-name'>Distance:</div>
                                <div class='alert-popup-row-value'>${distance_km ? `${(distance_km / 1.609).toFixed(2)} miles` : 'Unavailable'}</div>
                            </div>                                       
                        </div>
                        `)
                    .addTo(map.current);

                    map.current.on('mouseenter','Layer-Shelter-Symbol', _=> map.current.getCanvas().style.cursor='pointer');
                    map.current.on('mouseleave','Layer-Shelter-Symbol', _=> map.current.getCanvas().style.cursor='');

                })
            });

            }).catch((err) => {
                console.log('error getting shelters', err);
                setNearbyShelters([]);
            })
        }).catch((err) => console.log('error getting token', err));  
    }

    useEffect(() => {
        getShelters();

        return () => {
            setNearbyShelters(null);

            // Clean up popup
            if (popupRef.current) {
                popupRef.current.remove();
            }

            map.current.getStyle().layers
                .filter(l => l.id.startsWith('Layer-Shelter-'))
                .forEach(l => map.current.removeLayer(l.id));

            ['Source-Shelters','Source-Shelter-Routes'].forEach(src => {
            if (map.current.getSource(src)) map.current.removeSource(src);
            });

            if (map.current.hasImage('shelter-icon')) {
                map.current.removeImage('shelter-icon');
            }
        }
    }, []);

    return (
        !nearbyShelters ?
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', marginTop: '1.5rem' }}>
                <div style={{ fontSize: '0.8rem', color: 'black' }}>Searching for nearby shelters...</div>
                <Spinner />
            </div>
            : nearbyShelters.length === 0 ?
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                padding: '2rem',
                textAlign: 'center',
                color: '#666',
                marginTop: '1rem'
            }}>
                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                    No nearby shelters found
                </div>
                <div style={{ fontSize: '0.9rem' }}>
                    Try searching in a different area or check with local emergency services
                </div>
            </div>
            :     
            <div style={{ 
                maxWidth: '100%', 
                padding: '0.7rem', 
                marginTop: '1rem', 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '0.5rem', 
                backgroundColor: 'rgba(232, 232, 232, 0.497)', 
                borderRadius: 10
            }}>
                <div style={{ color: 'black', fontSize: '0.9rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.3rem' }}><img style={{ width: '1.2rem' }} src={shelterIcon}/>Nearby Shelters ({nearbyShelters ? nearbyShelters.length.toLocaleString() : 0}):</div>
                <div style={{ width: '100%', marginTop: '0.4rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
               <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingBottom: '1rem' }}>
                 {nearbyShelters
                   .sort((x, y) => x.distance_km - y.distance_km)
                   .map((i, idx) => (
                   <div
                     key={idx}
                     style={{
                       display: 'flex',
                       flexDirection: 'column',
                       borderBottom: '1px solid rgba(88,88,88,0.8)',
                       padding: '0.8rem 0.4rem',
                       gap: '0.6rem',
                       marginBottom: idx === nearbyShelters.length - 1 ? '1rem' : '0'
                     }}
                   >
                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                       <div
                         style={{
                           color: 'black',
                           fontSize: '0.9rem',
                           fontWeight: 'bold'
                         }}
                       >
                         {i.name ? i.name : i.full_name ? i.full_name : i.full_address ? i.full_address : 'Unknown Name'}
                       </div>
                       <div
                         style={{
                           color: '#666',
                           fontSize: '0.9rem',
                           marginTop: '0.2rem'
                         }}
                       >
                         {i.distance_km ? `${(i.distance_km / 1.609).toFixed(2)} miles away from fire` : 'Distance unavailable'}
                       </div>
                     </div>
                     <div
                       onClick={() => { 
                        map.current.flyTo({ center: i.coordinates, zoom: 18, pitch: 0 });
                        showShelterPopup(i.coordinates, i);
                       }}
                       style={{
                         width: '100%',
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                         gap: '0.6rem',
                         fontSize: '0.8rem',
                         color: 'white',
                         fontWeight: '600',
                         borderRadius: '8px',
                         padding: '0.4rem 0',
                         cursor: 'pointer',
                         background: 'linear-gradient(135deg, #0080ff 0%, #0056b3 100%)',
                         transition: 'all 0.2s ease'
                       }}
                       onMouseEnter={(e) => {
                         e.target.style.background = 'linear-gradient(135deg, #0056b3 0%, #004085 100%)';
                         e.target.style.transform = 'translateY(-1px)';
                         e.target.style.boxShadow = '0 4px 8px rgba(0, 123, 255, 0.3)';
                       }}
                       onMouseLeave={(e) => {
                         e.target.style.background = 'linear-gradient(135deg, #0080ff 0%, #0056b3 100%)';
                         e.target.style.transform = 'translateY(0)';
                         e.target.style.boxShadow = 'none';
                       }}
                     >
                       View
                     </div>
                   </div>
                 ))}
               </div>
             </div>
           </div>
            </div>
    )
}
